import { ColumnType } from "antd/es/table";
import {
  RubWithdrawalRequestsContent,
  WithdrawalRequestStatus,
  WITHDRAWAL_REQUEST_STATUSES,
  WithdrawalRequestStatusList,
  getEnumKeys,
  WITHDRAWAL_REQUEST_STATUSES_ENUM,
} from "interfaces";
import { Status, DisplayAmount } from "ui";
import { dateFormat, getFilterIcon, getSortIcon } from "utils";
import { UserStore } from "stores/UserStore";
import "styles/imageStyles.css";
import { RubWithdrawalRequestsList } from "stores/RubWithdrawalRequestsList";
import { Flex } from "antd";
import { ColumnActionBtn } from "../ColumnActionBtn";

import { ACTION_TYPE_ENUM } from "../ColumnActionBtn/actions";
import { ColumnShowInfoBtn } from "../ColumnActionBtn/ColumnShowInfoBtn";
import { SAFE_DEAL } from "utils/envConstants";

export const getColumns = (
  store: RubWithdrawalRequestsList,
  user: UserStore
): Array<ColumnType<RubWithdrawalRequestsContent>> => {
  const { isOperator } = user.roles;

  return [
    {
      dataIndex: "amount",
      key: "amount",
      title: "Сумма",
      sorter: true,
      sortIcon: getSortIcon,
      render: (_: any, record: RubWithdrawalRequestsContent) => {
        return (
          <DisplayAmount
            amount={record.amount || 0}
            currency={"RUB"}
            currencyList={{ RUB: "Российский рубль" }}
            showFlag
            squareBg
            withName
          />
        );
      },
    },
    {
      dataIndex: "created",
      key: "created",
      title: "Дата создания",
      sorter: true,
      sortIcon: getSortIcon,
      render: (date: string) => {
        return dateFormat(date, true);
      },
    },
    isOperator
      ? {
          dataIndex: "company.companyName",
          key: "company.companyName",
          title: "Организация",
          sorter: true,
          sortIcon: getSortIcon,
          render: (_: any, record: RubWithdrawalRequestsContent) => {
            return record.companyName;
          },
        }
      : null,

    {
      dataIndex: "statuses",
      key: "statuses",
      title: "Статус",

      filterMultiple: true,
      defaultFilteredValue: store.queryParams["statuses"],
      filtered: "statuses" in store.queryParams,
      filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      filters: getEnumKeys(WITHDRAWAL_REQUEST_STATUSES.texts).map((key) => ({
        text: WITHDRAWAL_REQUEST_STATUSES.texts[key],
        value: key,
      })),
      render: (_: any, record: RubWithdrawalRequestsContent) => {
        return (
          <Flex justify="start">
            {
              <Status
                tooltip={`Обновлен ${dateFormat(record.statusDate, true)}`}
                color={
                  WithdrawalRequestStatusList.includes(record.status)
                    ? WITHDRAWAL_REQUEST_STATUSES.colors[record.status as WithdrawalRequestStatus]
                    : "gray"
                }
              >
                {WithdrawalRequestStatusList.includes(record.status)
                  ? WITHDRAWAL_REQUEST_STATUSES.texts[record.status as WithdrawalRequestStatus]
                  : record.status}
              </Status>
            }
          </Flex>
        );
      },
    },
    {
      key: "fileIcon",
      title: "Действия по заявке",
      width: 170,
      render: (_: any, record: RubWithdrawalRequestsContent) => {
        return (
          <Flex gap="xsmall" justify="end">
            {record.status === WITHDRAWAL_REQUEST_STATUSES_ENUM.CREATED && isOperator && !SAFE_DEAL ? (
              <ColumnActionBtn
                bidId={record.id}
                actionType={ACTION_TYPE_ENUM.START_PROCESSING}
                variant="text"
                tooltip="Взять в работу"
              />
            ) : record.status === WITHDRAWAL_REQUEST_STATUSES_ENUM.PROCESSING && isOperator && !SAFE_DEAL ? (
              <ColumnActionBtn
                bidId={record.id}
                actionType={ACTION_TYPE_ENUM.PROCESSING}
                variant="text"
                tooltip="Подтвердить"
              />
            ) : null}

            <ColumnShowInfoBtn companyId={record.companyId} />

            {isOperator &&
              !SAFE_DEAL &&
              record.status !== WITHDRAWAL_REQUEST_STATUSES_ENUM.CANCELLED &&
              record.status !== WITHDRAWAL_REQUEST_STATUSES_ENUM.COMPLETED && (
                <ColumnActionBtn
                  bidId={record.id}
                  actionType={ACTION_TYPE_ENUM.CANCEL}
                  variant="text"
                  tooltip="Отменить заявку"
                />
              )}
          </Flex>
        );
      },
    },
  ].filter((col) => !!col) as Array<ColumnType<RubWithdrawalRequestsContent>>;
};
